// extracted by mini-css-extract-plugin
module.exports = {"brandGreen":"#00c273","gray":"#555","container":"BiblioboardBanner__container___1BNhY"};